import { Formatter } from './Formatter.js';
// These segments are currently not straightforward to detect automatically because
// the webshop app uses imperative navigation instead of a central route table.
// Keep this list in sync with the webshop app and look into automating this.
export const reservedWebshopPathSegments = [
    'checkout',
    'order',
    'cart',
    'payment',
    'tickets',
    'code',
];
export function isReservedWebshopPathSegment(segment) {
    return segment.length <= 2 || reservedWebshopPathSegments.includes(Formatter.slug(segment));
}
//# sourceMappingURL=WebshopRoutes.js.map